var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer sticky footer-type-1"},[_c('div',{staticClass:"footer-inner"},[_c('div',{staticClass:"footer-text"},[_c('a',{attrs:{"href":"#"}},[_c('strong',[_vm._v("安徽合大数据服务有限公司")])])])])])
}]

export { render, staticRenderFns }